export const KIRO_TARGET = 'kiro';

// Project-level paths
export const KIRO_AGENTS_MD = 'AGENTS.md';
export const KIRO_DIR = '.kiro';
export const KIRO_STEERING_DIR = `${KIRO_DIR}/steering`;
export const KIRO_SKILLS_DIR = `${KIRO_DIR}/skills`;
export const KIRO_AGENTS_DIR = `${KIRO_DIR}/agents`;
export const KIRO_HOOKS_DIR = `${KIRO_DIR}/hooks`;
export const KIRO_SETTINGS_DIR = `${KIRO_DIR}/settings`;
export const KIRO_MCP_FILE = `${KIRO_SETTINGS_DIR}/mcp.json`;
export const KIRO_IGNORE = '.kiroignore';

export const KIRO_GLOBAL_STEERING_DIR = '.kiro/steering';
export const KIRO_GLOBAL_STEERING_AGENTS_MD = '.kiro/steering/AGENTS.md';
export const KIRO_GLOBAL_SKILLS_DIR = '.kiro/skills';
export const KIRO_GLOBAL_AGENTS_DIR = '.kiro/agents';
export const KIRO_GLOBAL_MCP_FILE = '.kiro/settings/mcp.json';
export const KIRO_GLOBAL_IGNORE = '.kiro/settings/kiroignore';

// Compatibility mirror paths
export const KIRO_GLOBAL_AGENTS_SKILLS_DIR = '.agents/skills';

// Canonical paths
export const KIRO_CANONICAL_ROOT_RULE = '.agentsmesh/rules/_root.md';
export const KIRO_CANONICAL_RULES_DIR = '.agentsmesh/rules';
export const KIRO_CANONICAL_AGENTS_DIR = '.agentsmesh/agents';
export const KIRO_CANONICAL_MCP = '.agentsmesh/mcp.json';
export const KIRO_CANONICAL_HOOKS = '.agentsmesh/hooks.yaml';
export const KIRO_CANONICAL_IGNORE = '.agentsmesh/ignore';
